import React from 'react';
import User from '../../domain/User';
import Color from '../../domain/Color';
import Locale from '../../domain/Locale';
import Mobile from '../../domain/Mobile';
import Country from '../../domain/Country';
import SponsorDomain from '../../domain/Sponsor';
import get_bundle from '../../domain/get_bundle';
import Pin from '../../domain/Pin';
import countries from '../../domain/countries';
import UserHeader from '../../components/header/User';
import Layout from '../../components/Layout';
import Sponsor from '../../components/Sponsor';
import Message from '../../components/Message';
import MarkdownComponent from '../../components/MarkdownComponent';
import Alert from '../../components/Alert';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  country: Country,
  message: t.maybe(t.ReactElement),
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  mobile: Mobile,
  user: User,
  sponsor: t.maybe(SponsorDomain),
  doInsertPin: t.Func,
  goProduct: t.Func,
  goChangePassword: t.Func,
  goPurchases: t.Func,
  doLogout: t.Func,
  doAcceptCookies: t.Func,
  partners: t.maybe(t.Obj)
})
export default class InsertPin extends React.Component {

  constructor(...args) {
    super(...args);
    this.state = {
      options: this.getOptions()
    };
  }

  getBgColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.bg_color;
  }

  getColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.color;
  }

  onSubmit = (evt) => {
    evt.preventDefault();
    const value = this.refs.form.getValue();
    if (value) {
      this.props.doInsertPin(value.code);
    }
  }

  getFormType() {
    return t.struct({
      code: Pin
    });
  }

  getOptions() {
    return {
      auto: 'none'
    };
  };

  getMobile() {
    return countries.format_mobile(this.props.country, this.props.mobile);
  };

  getHeader() {
    return (
      <UserHeader
        locale={this.props.locale}
        goPurchases={this.props.goPurchases}
        goChangePassword={this.props.goChangePassword}
        doLogout={this.props.doLogout}
        goProduct={this.props.goProduct}
        user={this.props.user}
        color={this.getColor()}
        themeBtnColor={this.props.themeBtnColor}
        themeBtnFontColor={this.props.themeBtnFontColor} />);
  }

  getSxContent() {
    const bundle = get_bundle(this.props.locale).request_pin;
    return (
      <div className="left-image">
        <div className="left-claim">
          <div className="cell">
            <MarkdownComponent>{bundle.claim.call_to_action}</MarkdownComponent>
          </div>
          <div className="cell">
            <MarkdownComponent>{bundle.claim.safe}</MarkdownComponent>
          </div>
          <div className="cell">
            <MarkdownComponent>{bundle.claim.free}</MarkdownComponent>
          </div>
        </div>
      </div>
    );
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor sponsor={this.props.sponsor} locale={this.props.locale} options={options} />);
  }

  getMessage() {
    return (<Message bgColor={this.props.themeBgColor} fontColor={this.props.themeBgFontColor}>{get_bundle(this.props.locale).insert_pin.title}</Message>);
  }

  render() {
    const locale = this.props.locale;
    const bundle = get_bundle(locale).insert_pin;

    const btnStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };

    return (
      <Layout header={this.getHeader()} partners={this.props.partners} sponsor={this.getSponsor()} bgColor={this.getBgColor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <div id="insert_pin" className="cols">
          <div className="large-100">
            <div className="large-60 small-hide">
              <div className="cell">
                { this.getSxContent() }
              </div>
            </div>
            <div className="large-40 large-pull-right small-100">
              <div className="cell border-radius-all">
                { this.getMessage() }
                <div className="box light">
                  <p>{bundle.sub_title} {this.getMobile()}</p>
                  <form onSubmit={this.onSubmit}>
                    <t.form.Form
                      ref="form"
                      type={this.getFormType()}
                      options={this.state.options}/>
                    <button className="btn" style={btnStyle}>{bundle.do_insert_pin}</button>
                  </form>
                </div>
              </div>
              <div className="cell">
                <Alert type="warning">
                  <MarkdownComponent>{bundle.help}</MarkdownComponent>
                </Alert>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/InsertPin.js
 **/